module.exports = __webpack_public_path__ + "static/red-logo@3x-f11632f39f412e26b6e7520fd04786b6.png";